const PAGE_TITLE0 = "Start the application";
const PAGE_TITLE04 = "Tell us a little bit about your company";
const PAGE_TITLE4 = "Time to Apply for Workers' Compensation";
const PAGE_TITLE_SUBMITTED = "You did it!";
const PAGE_TITLE_LINK = "Back to Dashboard";
const BACK_BUTTON_TEXT = "Back";
const NEXT_BUTTON_TEXT = "Save & continue";
const LOADING_BUTTON_TEXT = "Loading";
const CANCEL_BUTTON_TEXT = "Cancel";
const DELETE_BUTTON_TEXT = "Delete";
const SAVE_BUTTON_TEXT = "Save";
const SUBMIT_BUTTON_TEXT = "Submit";

const STEPS_FOR_OWNER_EMPLOYEE_MERGE_TEST_VARIANT = [
  { label: "Business details" },
  { label: "Office location" },
  { label: "Company staff" },
  { label: "About your team" },
  { label: "About your business" },
  { label: "Business attributes" },
  { label: "Attach documents" },
  { label: "Employment Practice Liability Insurance (EPLI)" },
  { label: "Review & submit" },
];

const REVIEW_TITLE = "Review & submit";
const REVIEW_DESCRIPTION = "Here’s a recap of everything you entered.";

export {
  PAGE_TITLE0,
  PAGE_TITLE04,
  PAGE_TITLE4,
  PAGE_TITLE_LINK,
  PAGE_TITLE_SUBMITTED,
  BACK_BUTTON_TEXT,
  NEXT_BUTTON_TEXT,
  LOADING_BUTTON_TEXT,
  CANCEL_BUTTON_TEXT,
  DELETE_BUTTON_TEXT,
  SAVE_BUTTON_TEXT,
  REVIEW_TITLE,
  REVIEW_DESCRIPTION,
  SUBMIT_BUTTON_TEXT,
  STEPS_FOR_OWNER_EMPLOYEE_MERGE_TEST_VARIANT,
};
